import React from 'react';
import PropTypes from 'prop-types';
import BaseViewForm from '../0-base-view-form';

import FormManager from 'src/core/gd-form/common/form-manager';
import SelectProjectMulti from "../common-blocks/project-multi";
import CommonBlock from "../common-blocks/common-block";
import CommonForm from "../common-blocks/common-form";
import {ViewType} from "../../../../../../../core/gd/const/views/view-type";
import {ViewTypeConfigs} from "../../../../../../../core/gd/const/views/view-type-config";
import {EntityType} from "../../../../../../../core/gd/const/item"

export default class PortfolioForm extends BaseViewForm {

    static propTypes = {
        mode: PropTypes.oneOf(['create', 'update']).isRequired,
        organizationId: PropTypes.string.isRequired,
        view: PropTypes.object,

        onSubmit: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.viewType = ViewType.PROJECTS_PORTFOLIO;
        this.defaultName = ViewTypeConfigs[this.viewType].name;

        const initFormData = this.getViewInitFormData(this.props.view, {
            projects: []
        });

        // patch location
        initFormData.location = 'projects';

        if (this.props.view && this.props.view.settings) {
            initFormData.projects =     this.props.view.settings.projects;
        }

        const formStructure = {
            fields: this.getViewFormFields({
                projects:   {type: 'select',    isRequired: false,  validator: value=>value.length === 0 ? "No projects selected" : true}
            }),
            onSubmit: this.onSubmit,
            isFormChanged: true,
        };

        this.form = new FormManager(formStructure, initFormData);
    }

    onParentSelect = (parent) => {
        this.form.onFormComponentValueChange('projects', parent.projects);
        this.updateUsersField('sharedUsers');
        this.forceUpdate();
    }

    onSubmit = (result) => {
        this.submitData(result, {
            projects: result.projects,
        });
    }

    render() {
        const users = this.getUsers();

        return (
            <CommonForm className={this.props.className} form={this.form} mode={this.props.mode}>
                <div className="tbl">
                    <CommonBlock form={this.form} mode={this.props.mode} view={this.props.view} users={users}/>

                    <SelectProjectMulti placeholder                 = "Select projects"
                                        form                        = {this.form}
                                        parentsFor                  = {EntityType.PROJECT}
                                        companyId                   = {this.props.organizationId}
                                        inheritedChildrenSelection  = {false}
                                        multiselectCheckboxType     = "filled"
                                        onParentSelect              = {this.onParentSelect}  />

                    <div className="cf" /> {/* not to break submit in form-modal */}
                </div>
            </CommonForm>
        );
    }
}